<template>
  <v-card class="mt-0 flex d-flex flex-column" outlined :loading="loading">
    <v-card-title class="justify-center"> Upcoming Downgrades </v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="subscriptions"
        :items-per-page="size"
        :server-items-length="serverItemsLength"
        :options.sync="paginationOptions"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100]
        }"
        @update:options="updatePaginationOptions($event)"
        class="elevation-0"
        dense
      >
        <template v-slot:item.companyName="{ item }">
          <router-link
            :to="{
              name: 'CompanyShow',
              params: { companyId: item.companyId }
            }"
          >
            {{ item.companyId }} -
            {{ item.companyName }}
          </router-link>
        </template>

        <template v-slot:item.startDate="{ item }">
          {{ item.startedAt | date }}
        </template>

        <template v-slot:item.downgradeDate="{ item }">
          {{ getSubscriptionCancelDate(item.startedAt) | date }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { listSubscriptions } from "../../api/subscription";
import {
  parseISO,
  getDate,
  endOfMonth,
  setDate,
  startOfToday,
  addMonths
} from "date-fns";

export default {
  name: "UpcomingDowngrades",

  data() {
    return {
      loading: false,
      subscriptions: [],
      page: 0,
      size: 10,
      serverItemsLength: 0,
      paginationOptions: {
        itemsPerPage: 10,
        page: 1
      },
      headers: [
        {
          text: "Listing ID",
          sortable: false,
          value: "facilityId"
        },
        {
          text: "Listing Name",
          sortable: false,
          value: "facilityName"
        },
        {
          text: "Provider",
          sortable: false,
          value: "companyName"
        },
        {
          text: "Start Date",
          sortable: false,
          value: "startDate"
        },
        {
          text: "Downgrade Date",
          sortable: false,
          value: "downgradeDate"
        }
      ]
    };
  },

  mounted() {
    this.searchSubscriptions();
  },

  methods: {
    async searchSubscriptions() {
      this.offset = 0;
      this.paginationOptions.page = 1;

      await this.getSubscriptions();
    },

    updatePaginationOptions(paginationOptions) {
      this.page = paginationOptions.page - 1;
      this.size = paginationOptions.itemsPerPage;

      this.getSubscriptions();
    },

    async getSubscriptions() {
      try {
        this.loading = true;
        const result = await listSubscriptions(
          this.page,
          this.size,
          null,
          true
        );
        this.serverItemsLength = result.total;
        this.subscriptions = result.items;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error(e);
      }
    },
    getSubscriptionCancelDate(dateString) {
      const startDate = parseISO(dateString);

      const todayDate = getDate(new Date());
      const startDateDate = getDate(startDate);
      const endOfMonthDate = getDate(endOfMonth(new Date()));

      let cancelDate = setDate(startOfToday(), startDateDate);

      if (startDateDate > endOfMonthDate) {
        cancelDate = setDate(startOfToday(), endOfMonthDate);
      }

      if (todayDate > startDateDate) {
        const endOfMonthNextMonth = getDate(
          endOfMonth(addMonths(startOfToday(), 1))
        );
        if (startDateDate > endOfMonthNextMonth) {
          cancelDate = setDate(
            addMonths(startOfToday(), 1),
            endOfMonthNextMonth
          );
        } else {
          cancelDate = setDate(addMonths(startOfToday(), 1), startDateDate);
        }
      }

      return cancelDate;
    }
  }
};
</script>
